import { faVolumeMute, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Logger } from 'logger';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import { muteEvents } from 'redux/events/actions';
import { voiceOptions } from '../../assets/sounds/widgetAudio';

const AUDIBLE_ID = 5

const debugLog = Logger.create('Audible:index.tsx')

const config = [
  'ES1',
  'ES5',
  'ES60',
  'NQ1',
  'NQ5',
  'NQ60',
]

const activeRally = {
  ES1: '',
  ES5: '',
  ES60: '',
  NQ1: '',
  NQ5: '',
  NQ60: '',
}

interface IProps {
  muteEvents: (muted: boolean) => void,
}

const AudibleComponent: React.FunctionComponent<IProps> = ({ muteEvents }) => {
  const [speakerState, setSpeakerState] = useState<boolean | null>(null);

  useEffect(() => {
    config.forEach(key => {
      subscribeListener(`watchbox:VPM${key}`, AUDIBLE_ID, ({ data }) => {
        if (data) {
          if (speakerState && activeRally[key] === '' && data.active_name !== '' && data.active_time === data.time) {
            if (data.active_name === 'SELL RALLY') {
              // send client_log (playing sound)
              voiceOptions[key].sell.play().catch((error: any) => debugLog(error));
            } else if (data.active_name === 'BUY DIP') {
              voiceOptions[key].buy.play().catch((error: any) => debugLog(error));
            }
          }
          activeRally[key] = data.active_name || ''
        }
      });
    })
    return () => {
      config.forEach(key => {
        unsubscribeListener(`watchbox:VPM${key}`, AUDIBLE_ID);
      })
    }
  }, [speakerState])

  useEffect(() => {
    if (speakerState !== null) muteEvents(!speakerState);
  }, [speakerState, muteEvents]);

  const speakerSwitch = () => {
    debugLog('Switching speaker state')
    setSpeakerState(s => !s);
  }

  return (
      <div onClick={speakerSwitch} style={{ cursor: 'pointer' }}>
        { speakerState ?
            <FontAwesomeIcon size="1x" icon={faVolumeUp} title="Mute" />
          :
            <FontAwesomeIcon size="1x" icon={faVolumeMute} title="Mute" />
        }
      </div>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  muteEvents: (muted: boolean) => dispatch(muteEvents(muted)),
});

export const Audible = connect(null, mapDispatchToProps)(AudibleComponent);
